// Module
var code = " <full-data-view-directive></full-data-view-directive> ";
// Exports
module.exports = code;